import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { minBreakpointQuery, zIndexLayers } from '../styles';
import { Link } from './ui';
import christmasLogo from '../images/christmas-logo.svg';
import logo from '../images/anniversary-logo.svg';

const StyledLogo = styled(Link)`
  display: inline-block;
  z-index: ${zIndexLayers.fourth};
  position: relative;
`;

const StyledImage = styled.img`
  height: 42px;

  ${minBreakpointQuery.large`
    height: 34px;
  `}

  ${minBreakpointQuery.xlarge`
    height: 44px;
  `}

  ${minBreakpointQuery.xxlarge`
    height: 54px;
  `}
`;

const Logo = ({ link, isHeader, enableChristmasLogo }) => {
  const {
    datoCmsSite: {
      globalSeo: { siteName },
    },
  } = useStaticQuery(graphql`
    query LogoQuery {
      datoCmsSite {
        globalSeo {
          siteName
        }
      }
    }
  `);

  return (
    <StyledLogo to={link ? link.pageUrl : '/'}>
      <StyledImage
        src={enableChristmasLogo ? christmasLogo : logo}
        alt={siteName}
        loading={isHeader ? 'eager' : 'lazy'}
      />
    </StyledLogo>
  );
};

export default Logo;
